import { useEffect, useState } from 'react';
import './admin-settings.css';
import { HashLoader } from 'react-spinners';
import ToastNotification, { showToast } from '../../components/toasts/ToastNotification';
import { getSettings, updateSettings, updateTermOfService, updatePrivacyPolicy } from '../../api/settings.api';

export const AdminSettings = () => {
  const [settings, setSettings] = useState({});
  const [term, setTerm] = useState([]);
  const [privacy, setPrivacy] = useState([]);

  const [termText, setTermText] = useState('');
  const [privacyText, setPrivacyText] = useState('');

  const [loading, setLoading] = useState(false);

  const [rawJson, setRawJson] = useState('');


  useEffect(() => {
    fetchSettings();
    document.title = 'Cài đặt Website';
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const res = await getSettings();
      if (res.success && res.data?.settings?.config) {
        const parsedSettings = JSON.parse(res.data.settings.config);
        setSettings(JSON.parse(res.data.settings.config));
        setRawJson(JSON.stringify(parsedSettings, null, 2));
        setTerm(res.data.settings.term_of_service);
        setPrivacy(res.data.settings.privacy_policy);

        setTermText(JSON.stringify(res.data.settings.term_of_service, null, 2));
        setPrivacyText(JSON.stringify(res.data.settings.privacy_policy, null, 2));
      } else {
        showToast("Không tìm thấy cấu hình", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi tải cấu hình", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSettings = async () => {
    setLoading(true);
    try {
      const res = await updateSettings(settings);
      if (res.success) {
        showToast("Cập nhật thành công", "success");
        fetchSettings();
      } else {
        showToast("Cập nhật thất bại", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi cập nhật", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateTerm = async () => {
    setLoading(true);
    try {
      const res = await updateTermOfService(term);
      if (res.success) {
        showToast("Cập nhật thành công", "success");
        fetchSettings();
      } else {
        showToast("Cập nhật thất bại", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi cập nhật", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePrivacy = async () => {
    setLoading(true);
    try {
      const res = await updatePrivacyPolicy(privacy);
      if (res.success) {
        showToast("Cập nhật thành công", "success");
        fetchSettings();
      } else {
        showToast("Cập nhật thất bại", "error");
      }
    } catch (error) {
      showToast(error.message || "Lỗi khi cập nhật", "error");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <HashLoader color="#092339" />
      </div>
    );
  }

  return (
    <div className='admin-settings-container'>
      <ToastNotification />

      {/* SETTINGS */}
      <div className='web-config-card'>
        <p className='web-config-title'>Cấu hình Site</p>
        <p>JSON</p>
        <textarea
          className='web-config-text'
          rows="12"
          cols="70"
          value={rawJson}
          onChange={(e) => {
            const newValue = e.target.value;
            setRawJson(newValue);

            try {
              const parsed = JSON.parse(newValue);
              setSettings(parsed); // only update if valid
            } catch {
              // keep rawJson so user can keep typing
            }
          }}
        />
        <button
          onClick={handleUpdateSettings}
          disabled={loading}
          className='update-settings-button'>
          Cập nhật
        </button>
      </div>

      {/* TERM OF SERVICE */}
      <div className='web-config-card'>
        <p className='web-config-title'>Cấu hình Điều khoản dịch vụ</p>
        <p>Array</p>
        <textarea
          className='web-config-text'
          rows="12"
          cols="70"
          value={termText}
          onChange={(e) => {
            setTermText(e.target.value);
            try {
              setTerm(JSON.parse(e.target.value));
            } catch {
              // Allow editing even when JSON is invalid
            }
          }}
        />
        <button
          onClick={handleUpdateTerm}
          disabled={loading}
          className='update-settings-button'>
          Cập nhật
        </button>
      </div>

      {/* PRIVACY POLICY */}
      <div className='web-config-card'>
        <p className='web-config-title'>Cấu hình Chính sách bảo mật</p>
        <p>Array</p>
        <textarea
          className='web-config-text'
          rows="12"
          cols="70"
          value={privacyText}
          onChange={(e) => {
            setPrivacyText(e.target.value);
            try {
              setPrivacy(JSON.parse(e.target.value));
            } catch {
              // Allow editing even when JSON is invalid
            }
          }}
        />
        <button
          onClick={handleUpdatePrivacy}
          disabled={loading}
          className='update-settings-button'>
          Cập nhật
        </button>
      </div>
    </div>
  );
};
